import styled from "styled-components";

import { bgLight } from "assets/images";

export const LayoutContainer = styled.div`
  .app {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;
    background-color: ${({ theme }) => theme.global.bg.primary};

    background-size: 100% 100%;
    -o-background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    background-size: cover;
    background-repeat: no-repeat;

    &.auth-app {
      background: ${({ theme }) => theme.global.bg.auth};
      background-image: none;
    }

    .col-3:first-child {
      padding-right: 0;
    }
    > .col-9 {
      padding-left: 0;
    }
    .dropdown-menu {
      background: ${({ theme }) => theme.dropdown.bg.primary} !important;
      border: 1px solid ${({ theme }) => theme.input.border.color} !important;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.22) !important;
      border-radius: ${({ theme }) =>
        theme.constants.BORDER_RADIUS_5} !important;
      padding: 8px 6px;

      .dropdown-divider {
        border-top: 1px solid ${({ theme }) => theme.global.border.secondary};
        margin: 0.4em 0.75em;
      }

      .dropdown-item {
        color: ${({ theme }) => theme.dropdown.font.primary};
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;

        &:hover {
          background: ${({ theme }) => theme.dropdown.hover.primary};
          border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_5};
        }
      }
    }
    .app-content {
      width: 100%;

      .screen {
        width: ${({ version }) =>
          version !== "v1" ? "calc(100% - 240px)" : "calc(100% - 170px)"};
        height: auto;
        /* overflow: auto; */
        margin-left: ${({ version }) => (version !== "v1" ? "240px" : "170px")};
        padding-top: 60px;
      }
    }
  }
  .theme-light {
    background-image: url("${bgLight}");
  }

  @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {
    .app-content {
      padding-top: 30px !important;
    }
  }
  @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
    .app-content {
      padding-top: 30px !important;
    }
  }

  @media (max-width: 768px) {
    .app-content .screen {
      margin-left: 0;
      width: 100%;
    }

    .app .app-content .screen {
      margin-left: 0;
      width: 100%;
      max-height: 100dvh;
    }
  }

  @media (max-width: 390px) {
    .app .app-content .screen {
      padding-top: 60px;
    }
  }

  @media (max-width: 992px) {
    .screen .content.disabled-scroll {
      overflow-y: auto;
    }
  }
`;

export const LayoutContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 60px);
  max-height: 100%;
  padding: 1rem 1rem 3rem 1rem;
  position: relative;

  &.full-height {
    height: 100vh;
    padding-bottom: 0;
  }

  &.disabled-scroll {
    overflow-y: hidden;
  }

  &.no-sidebar {
    padding-left: 64px;
    padding-right: 64px;
  }

  @media (max-width: 768px) {
    padding: 16px 16px 90px;
    height: 100dvh;
    &.no-sidebar {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  @media (max-width: 388px) {
    padding: 16px 16px 16px 16px;
  }
`;
